import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { FaRegCircleUser } from "react-icons/fa6";
import { CiMail } from "react-icons/ci";
import { FiPhone } from "react-icons/fi";
import { FaSchoolFlag } from "react-icons/fa6";
import { FaShoppingBag } from "react-icons/fa";
import { CiBoxList } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";
import ban2 from "../../../assets/images/Header/Banner-Home/ban2.webp";

import btndk from "../../../assets/images/Chat/btndk.webp";
import { NotificationManager } from "react-notifications";
import loi from "../../../assets/images/Header/Banner-Home/loi.svg";
import bgban from "../../../assets/images/Header/Banner-Home/bgban.webp";
import vecot647 from "../../../assets/images/Header/Banner-Home/vecot647.svg";
import arrup from "../../../assets/images/Header/Banner-Home/arrup.svg";
import emo from "../../../assets/images/Header/Banner-Home/emo.svg";
import vecot648 from "../../../assets/images/Header/Banner-Home/vecot648.svg";
import dotve from "../../../assets/images/Header/Banner-Home/dotve.svg";
import ButtonDKN from "src/component/Button/ButtonDKN";
import axios from "axios";

// Nhập CSS của Swiper
import "swiper/css";
import "swiper/css/pagination";

/**
 * Custom hook để đếm số từ 0 tới `target` trong `duration` ms
 */
function useCountUp(target, duration = 2000) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = target / (duration / 30);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 30);
    return () => clearInterval(timer);
  }, [target, duration]);

  return count;
}

export default function Banner() {
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    center: "",
    position: "",
    service: "",
  });

  // Count-up values
  const price = useCountUp(8000000, 2000);
  const changePct = useCountUp(23.6, 2000);
  const followCount = useCountUp(168, 2000);
  const studentCount = useCountUp(1868, 2000);

  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateForm = () => {
    const phoneRegex = /^(0[1-9]{1}[0-9]{8,9})$/;
    if (!formData.name) {
      NotificationManager.error("Tên không được để trống!");
      return false;
    }
    if (!formData.email) {
      NotificationManager.error("Email không được để trống!");
      return false;
    }

    if (!formData.phone || !phoneRegex.test(formData.phone)) {
      NotificationManager.error("Số điện thoại phải có 10 hoặc 11 chữ số!");
      return false;
    }
    if (!formData.center) {
      NotificationManager.error("Tên trung tâm không được để trống!");
      return false;
    }
    if (!formData.position) {
      NotificationManager.error("Vui lòng chọn chức vụ!");
      return false;
    }
    if (!formData.service) {
      NotificationManager.error("Vui lòng chọn gói dịch vụ!");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateForm();
    if (!isValid) return;

    setIsLoading(true);
    try {
      const rowData = [
        formData.name,
        formData.email,
        formData.phone,
        formData.center,
        formData.position,
        formData.service,
        new Date().toLocaleString(),
        location.pathname,
      ];

      const response = await axios.post(
        "https://api-bluerise.bluerise.com.vn/contact-us",
        { values: rowData }
      );

      if (response.status === 200 && response.data) {
        NotificationManager.success("Thông tin đã được gửi thành công!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          center: "",
          position: "",
          service: "",
        });
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Error writing to Google Sheets:", error);
      NotificationManager.error(
        "Đã xảy ra lỗi khi gửi dữ liệu lên Google Sheets!" +
          JSON.stringify(error)
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="w-full bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${bgban})`,
      }}
    >
      {/* Mobile Layout */}
      <div className="block lg:hidden w-full">
        <div className="grid grid-cols-1 container gap-8 mx-auto px-[20px] pt-[40px] w-full">
          <div className="w-full flex flex-col gap-4 pt-12 z-10">
            <div className="w-full text-center lg:text-start text-[#053CC8]">
              <h2>GIẢI PHÁP CÔNG NGHỆ</h2>
            </div>
            <div className="flex items-center justify-center lg:items-start lg:flex lg:justify-start">
              <img src={loi} alt="loi" className=" object-cover" />
            </div>
            <div className="w-full text-center lg:text-start">
              <p className="text-[#032478] text-[16px] font-semibold">
                ĐƠN GIẢN QUẢN LÝ, TỐI ĐA HIỆU QUẢ
              </p>
              <p className="text-[#032478] text-[16px] font-semibold">
                DÀNH CHO TRUNG TÂM GIÁO DỤC
              </p>
            </div>
            <div className="flex items-center justify-center w-full lg:justify-start">
              <button
                onClick={handleButtonClick}
                className="px-4 py-2 bg-trangchu text-white w-full rounded-[30px]"
              >
                Dùng thử miễn phí
              </button>
            </div>
          </div>

          <div className="w-full pb-14 flex flex-col gap-6 ">
            <div className="border border-white bg-white flex flex-col items-center justify-center gap-2 w-[125px] h-[88px] px-[16px] py-[8px] rounded-[12px] shadow-md">
              <div>
                <img src={vecot647} alt="vecot" />
              </div>
              <div className="text-[#053CC8] font-semibold">
                {price.toLocaleString("de-DE")}đ
              </div>
              <div className="flex items-center gap-1">
                <div className="text-[#29B719]">{changePct.toFixed(1)}%</div>
                <div>
                  <img src={arrup} alt="arup" className="animate-bounce" />
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center absolute right-5 justify-center gap-2 border border-white bg-white w-[180px] h-[88px] px-[12px] py-[6px] rounded-[12px]">
              <div className="w-full flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <img src={emo} alt="emo" />
                  <p>Theo dõi</p>
                </div>
                <div>
                  <img src={dotve} alt="dove" />
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div className="text-[#053CC8] font-semibold">
                  {followCount}
                </div>
                <div className="flex items-center gap-1">
                  <p className="text-[#29B719]">{changePct.toFixed(1)}%</p>
                  <img
                    src={arrup}
                    alt="arp"
                    className="animate-bounce text-[#29B719]"
                  />
                </div>
              </div>
              <p className="text-[12px]">So với tuần trước</p>
            </div>

            <img
              src={ban2}
              alt="banner"
              className="w-full h-auto object-cover"
            />
            <div className="flex flex-row items-center relative -right-10 -top-10 justify-center gap-2 border border-white bg-white w-[280px] px-[12px] py-[6px] h-auto rounded-[12px]">
              <div>
                <img src={vecot648} alt="ve648" className="w-full h-auto" />
              </div>
              <div className="flex flex-col gap-1">
                <div className="text-[14px]">Tổng học viên</div>
                <div className="text-[12px] text-[#053CC8] font-semibold">
                  {studentCount.toLocaleString("de-DE")}
                </div>
                <div className="text-[12px]">Tăng 86 so với tháng trước</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:block w-full pt-24">
        <div className="flex flex-col md:flex-row gap-8 mx-auto container py-[30px] px-[24px] w-full items-center justify-center">
          <div className="w-full md:basis-7/12 relative ">
            <div className="border border-white bg-white absolute top-[120px] flex flex-col items-center justify-center gap-2 w-[125px] h-[88px] px-[16px] py-[10px] rounded-[12px] shadow-md">
              <div>
                <img src={vecot647} alt="vecot" />
              </div>
              <div className="text-[#053CC8] font-semibold">
                {price.toLocaleString("de-DE")}đ
              </div>
              <div className="flex items-center gap-1">
                <div className="text-[#29B719]">{changePct.toFixed(1)}%</div>
                <div>
                  <img src={arrup} alt="arup" className="animate-bounce" />
                </div>
              </div>
            </div>
            <div className="flex flex-row items-center absolute right-0 bottom-96 justify-center gap-2 border border-white bg-white w-[237px] px-[12px] py-[6px] h-auto rounded-[12px]">
              <div>
                <img src={vecot648} alt="ve648" className="w-full h-auto" />
              </div>
              <div className="flex flex-col gap-1">
                <div className="text-[14px]">Tổng học viên</div>
                <div className="text-[12px] text-[#053CC8] font-semibold">
                  {studentCount.toLocaleString("de-DE")}
                </div>
                <div className="text-[12px]">Tăng 86 so với tháng trước</div>
              </div>
            </div>
            <div className="flex flex-col items-center absolute bottom-20 left-32 justify-center gap-2 border border-white bg-white w-[190px] px-[12px] py-[6px] h-auto rounded-[12px]">
              <div className="w-full flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <img src={emo} alt="emo" />
                  <p>Theo dõi</p>
                </div>
                <div>
                  <img src={dotve} alt="dove" />
                </div>
              </div>
              <div className="text-[#053CC8] font-semibold">{followCount}</div>
              <div className="flex items-center gap-1">
                <p className="text-[#29B719]">{changePct.toFixed(1)}%</p>
                <img
                  src={arrup}
                  alt="arp"
                  className="animate-bounce text-[#29B719]"
                />
                <p className="text-[11px]">So với tuần trước</p>
              </div>
            </div>

            <img src={ban2} alt="banner" className=" object-cover" />
          </div>

          <div className="w-full md:basis-5/12 flex flex-col gap-4 md:gap-3 justify-center items-center z-10">
            <div className="text-center w-full lg:text-center ">
              <p className="text-[32px] text-[#053CC8] font-semibold">
                GIẢI PHÁP CÔNG NGHỆ
              </p>
            </div>

            <div className="w-full flex flex-col items-center justify-center gap-1 md:gap-5">
              <img src={loi} alt="loi" />
              <div>
                <p className="text-[#333333] text-[20px] font-medium text-center ">
                  ĐƠN GIẢN QUẢN LÝ, TỐI ĐA HIỆU QUẢ
                </p>
                <p className="text-[#333333] text-[20px] font-medium text-center ">
                  DÀNH CHO TRUNG TÂM GIÁO DỤC
                </p>
              </div>
            </div>

            <div className="flex items-center justify-center w-full lg:w-[190px] rounded-md lg:mt-2">
              <button
                onClick={handleButtonClick}
                className="px-5 py-2 bg-trangchu hover:bg-pa text-white text-[18px] rounded-[30px]"
              >
                Đăng ký tư vấn
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 w-full h-full bg-black rounded bg-opacity-50 flex justify-center items-center p-4 sm:p-6 z-50 overflow-y-auto"
          onClick={handleOverlayClick}
        >
          <div
            className="p-4 sm:p-6 rounded-lg w-full max-w-[400px] sm:max-w-[500px] md:max-w-[600px] shadow-custom-light flex flex-col gap-4 items-center relative bg-center bg-cover bg-no-repeat min-h-[480px] sm:min-h-[520px]"
            onClick={(e) => e.stopPropagation()}
            style={{ backgroundImage: `url(${btndk})` }}
          >
            <div
              className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-[#E6ECFA] absolute -top-3 -right-3 sm:-top-4 sm:-right-4 z-10 cursor-pointer"
              onClick={handleCloseModal}
            >
              <IoMdClose className="text-lg sm:text-xl" />
            </div>

            <div className="text-center">
              <p className="text-[20px] sm:text-[24px] font-semibold text-white mt-10 md:mt-2">
                ĐĂNG KÝ NHẬN TƯ VẤN
              </p>
            </div>

            <form
              onSubmit={handleSubmit}
              className="w-full mt-14 sm:mt-4 flex-1 flex flex-col justify-between"
            >
              <div className="w-full space-y-2 sm:space-y-4">
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full mt-5">
                  <FaRegCircleUser className="text-gray-500 mr-2 text-lg" />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Nhập họ và tên của bạn"
                    className="flex-1 bg-transparent border-none outline-none placeholder-gray-400 text-sm sm:text-base"
                  />
                </div>
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full">
                  <CiMail className="text-gray-500 mr-2 text-lg" />
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Nhập email của bạn"
                    className="flex-1 bg-transparent border-none outline-none placeholder-gray-400 text-sm sm:text-base"
                  />
                </div>
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full">
                  <FiPhone className="text-gray-500 mr-2 text-lg" />
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Nhập số điện thoại của bạn"
                    className="flex-1 bg-transparent border-none outline-none placeholder-gray-400 text-sm sm:text-base"
                  />
                </div>
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full">
                  <FaSchoolFlag className="text-gray-500 mr-2 text-lg" />
                  <input
                    type="text"
                    name="center"
                    value={formData.center}
                    onChange={handleChange}
                    placeholder="Nhập tên trung tâm bạn đang làm việc"
                    className="flex-1 bg-transparent border-none outline-none placeholder-gray-400 text-sm sm:text-base"
                  />
                </div>
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full text-gray-500">
                  <FaShoppingBag className="text-gray-500 mr-2 text-lg" />
                  <select
                    name="position"
                    value={formData.position}
                    onChange={handleChange}
                    className="flex-1 bg-transparent outline-none border-none placeholder-gray-400 text-sm sm:text-base"
                  >
                    <option value="">Chức vụ của bạn</option>
                    <option value="Giám đốc Trung Tâm">
                      Giám đốc Trung Tâm
                    </option>
                    <option value="Quản lý Trung Tâm">Quản lý Trung Tâm</option>
                    <option value="Giáo viên">Giáo viên</option>
                    <option value="Gia sư">Gia sư</option>
                    <option value="Học sinh">Học sinh</option>
                    <option value="Trợ giảng">Trợ giảng</option>
                  </select>
                </div>
                <div className="flex items-center border border-gray-300 rounded-lg p-2 w-full text-gray-500">
                  <CiBoxList className="text-gray-500 mr-2 text-lg" />
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="flex-1 bg-transparent outline-none border-none placeholder-gray-400 text-sm sm:text-base"
                  >
                    <option value="">Chọn gói dịch vụ cần tư vấn</option>
                    <option value="Basic">Basic</option>
                    <option value="Premium">Premium</option>
                    <option value="Unlimited">Unlimited</option>
                  </select>
                </div>
              </div>
              <button
                type="submit"
                className="w-full py-2 sm:py-3 bg-[#053CC8] text-white rounded-[30px] text-sm sm:text-base mt-4"
                disabled={isLoading}
              >
                {isLoading ? "Đang gửi..." : "Đăng ký"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
